
export enum EnumTipoOrdenacaoNovaGuia {
  OrdemAlfabetica,
  MaisLidos,
  MenosLidos,
  DataAlteracao,
}
